module.exports = __webpack_public_path__ + "assets/normal/images/quzi-co.3d0e33c9.png";